import { AiModal } from '@ui/modals';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { getQueryString } from '@sonar-software/sonar-http';
import React from 'react';
import { SparkleIconWhite } from '@ui/general';
import { useBoolean } from '@hooks';

import { FeatureFlag, PostAuditTrailExportRequest } from '@sonar-software/sonar-core';

export interface AuditTrailSummarizeButtonProps {
	disabled?: boolean;
	queryParams: PostAuditTrailExportRequest;
}

export const AuditTrailSummarizeButton: React.FC<AuditTrailSummarizeButtonProps> = ({ disabled, queryParams }) => {
	const [ open, setOpen ] = useBoolean(false);

	return (
		<FeatureBoundary feature={ FeatureFlag.AIWorkflowSetupAuditTrailChangesSummary }>
			<Button
				className='audit-trail-ai-summarize-button'
				disabled={ disabled }
				icon={ <SparkleIconWhite /> }
				onClick={ setOpen.on }
				type='primary'>
				{ COPY_SPECIFIC.SUMMARIZE }
			</Button>
			<AiModal
				className='audit-trail-ai-summarize-modal'
				onClose={ setOpen.off }
				open={ open }
				sourceUrl={ `/api/v3/open-ai/chat/setup-audit-trail-summary?${getQueryString(queryParams)}` }
				title={ COPY_SPECIFIC.SETUP_AUDIT_TRAIL_SUMMARY } />
		</FeatureBoundary>
	);
};
